import React from 'react';

const useCountdown = (toInMilliseconds: number) => {
  const [countdown, setCountdown] = React.useState(
    toInMilliseconds - Date.now(),
  );

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (countdown !== 0) {
        if (countdown > 0)
          setCountdown(prev => (prev - 1000 <= 0 ? 0 : prev - 1000));
        else setCountdown(0);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [countdown]);

  return countdown;
};

export default useCountdown;
